import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import WaterIcon from "@mui/icons-material/Water";
import gallery1 from "../../../assets/projects/img_1.JPG";
import gallery2 from "../../../assets/projects/img_2.JPG";
import gallery3 from "../../../assets/projects/img_3.JPG";
import gallery4 from "../../../assets/projects/img_4.JPG";
import gallery5 from "../../../assets/projects/img_5.JPG";
import gallery6 from "../../../assets/projects/img_6.JPG";
import gallery7 from "../../../assets/projects/img_7.JPG";
import gallery8 from "../../../assets/projects/img_8.JPG";
import gallery9 from "../../../assets/projects/img_9.JPG";
import gallery10 from "../../../assets/projects/img_10.JPG";
import gallery11 from "../../../assets/projects/img_11.JPG";
import gallery12 from "../../../assets/projects/img_12.JPG";
import gallery13 from "../../../assets/projects/img_13.JPG";
import gallery14 from "../../../assets/projects/img_14.JPG";
import gallery15 from "../../../assets/projects/img_15.JPG";
import gallery16 from "../../../assets/projects/img_16.JPG";
import gallery17 from "../../../assets/projects/img_17.JPG";
import gallery18 from "../../../assets/projects/img_18.JPG";
import gallery19 from "../../../assets/projects/img_19.JPG";
import gallery20 from "../../../assets/projects/img_20.JPG";
import gallery21 from "../../../assets/projects/img_21.JPG";
import gallery22 from "../../../assets/projects/img_22.JPG";
import gallery23 from "../../../assets/projects/img_23.JPG";
import gallery24 from "../../../assets/projects/img_24.JPG";

const Aip = () => {
  const theme = useTheme();

  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  const photos = [
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,
    gallery10,
    gallery11,
    gallery12,
    gallery13,
    gallery14,
    gallery15,
    gallery16,
    gallery17,
    gallery18,
    gallery19,
    gallery20,
    gallery21,
    gallery22,
    gallery23,
    gallery24,
  ];

  const photosToShow = isMd ? photos : photos.slice(0, photos.length);

  return (
    <Box padding={{ xs: "10% 0%", sm: "4% 0%" }}>
      <Box>
        <Box>
          <Typography
            variant="h6"
            color="#9DCC49"
            fontWeight={800}
            paddingTop={"5%"}
            paddingBottom={"2%"}
            textAlign={"left"}
          >
            <Box component={"span"}>
              <WaterIcon
                sx={{
                  width: 23,
                  height: 23,
                }}
              />
            </Box>{" "}
            Aquaculture Intervention Program (AIP)
          </Typography>
        </Box>
      </Box>
      <Box marginTop={{ xs: "5%", sm: "2%" }}>
        {photosToShow.map((item, index) => (
          <Box
            component="img"
            height={{ xs: "27vh", sm: "200px" }}
            onClick={() => {
              setCurrentImageIndex(index);
              setIsViewerOpen(!isViewerOpen);
            }}
            sx={{
              cursor: "pointer",
              objectFit: "cover",
            }}
            src={item}
            alt={"aip_img"}
            marginRight={{ xs: "0%", sm: "0.5%" }}
            marginBottom={{ xs: "1%", sm: "0.5%" }}
            width={{ xs: "100%", sm: "23.5%" }}
          />
        ))}

        <FsLightbox
          toggler={isViewerOpen}
          sources={photos}
          slide={currentImageIndex + 1}
        />
      </Box>
    </Box>
  );
};

export default Aip;
